<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.84 28.27a2 2 0 000-3.54l-24.91-13a2 2 0 00-1.85 0l-24.92 13a2 2 0 000 3.54L13 31.84v11a2 2 0 00.25 1C16.55 49.8 23.73 53.5 32 53.5s15.45-3.7 18.75-9.66a2.07 2.07 0 00.25-1v-11l3-1.56v15.39a3.25 3.25 0 102 0V29.23zM32 14.64L54.75 26.5 48 30l-16 8.36L16 30l-6.75-3.5zm16 28c-2.83 4.87-8.93 7.89-16 7.89s-13.18-3-16-7.89V33.4l15.07 7.86a1.91 1.91 0 00.93.23 2 2 0 00.92-.22L48 33.41z"/></svg>